module.exports = __webpack_public_path__ + "img/mbl-signature-by-mag-1.89ade18.webp";